import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UaaService {
  private sharedData = new BehaviorSubject<{ uaa: any; periodo: any; personaCodigo: any; periodoNombre: any;}>({
    uaa: null,
    periodo: null,
    personaCodigo: null,
    periodoNombre: null
  });

  currentData = this.sharedData.asObservable();

  setVariable(variableName: 'uaa' | 'periodo' | 'personaCodigo' | 'periodoNombre', value: any) {
    const currentValues = this.sharedData.getValue();
    this.sharedData.next({ ...currentValues, [variableName]: value });
  }

  /** Reinicia el estado al cerrar sesión */
  reset() {
    this.sharedData.next({ uaa: null, periodo: null, personaCodigo: null, periodoNombre: null });
  }
}